import NextLink from 'next/link';
import React from 'react';
import { imageProxy } from 'tf-post-parser';
import { figtree, fraunces } from '../../Landing/fonts';
import { ArrowIcon } from '../../Landing/ui';
import FutureImage from '../../FutureImage';

// "Read more" cross-post card in the article's editorial voice — a wide,
// airy postcard: photo on the left, generous paper margins, Fraunces title.
const LinkTool = props => {
  const { title, description, image, author, permlink, isAmp } = props;

  if (!title || !description) return <></>;

  const href = isAmp ? `/amp/${author}/${permlink}` : `/@${author}/${permlink}`;

  return (
    <div className={`${figtree.className} tw-not-italic tw-my-12`}>
      <NextLink
        href={href}
        prefetch={false}
        className="tw-group tw-block tw-no-underline"
      >
        {/* tw-isolate keeps the rounded-corner clipping intact while the
            image inside transforms (Chrome repaints the radius without it) */}
        <div className="tw-isolate tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] tw-shadow-[0_24px_50px_-30px_rgba(29,45,40,0.4)] tw-transition-shadow tw-duration-300 hover:tw-shadow-[0_30px_60px_-28px_rgba(29,45,40,0.5)]">
          <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-stretch">
            {image && (
              <div className="tw-relative tw-isolate tw-aspect-[16/9] tw-w-full tw-shrink-0 tw-overflow-hidden tw-rounded-t-2xl sm:tw-aspect-auto sm:tw-w-56 sm:tw-rounded-l-2xl sm:tw-rounded-tr-none md:tw-w-64">
                {isAmp ? (
                  <amp-img
                    src={imageProxy(image, 250, 400)}
                    width={250}
                    height={400}
                  />
                ) : (
                  <FutureImage
                    src={image}
                    alt={title}
                    fill
                    sizes="(max-width: 640px) 100vw, 256px"
                    maxSrcSetWidth={800}
                    className="tw-object-cover"
                  />
                )}
              </div>
            )}
            <div className="tw-min-w-0 tw-flex-1 tw-px-7 tw-py-7 sm:tw-px-9 sm:tw-py-8">
              <div className="tw-flex tw-items-center tw-gap-2.5">
                <span className="tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-primary-700 dark:tw-text-primary-300">
                  Read more
                </span>
                <span className="tw-h-px tw-flex-1 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44]" />
              </div>
              <p
                className={`${fraunces.className} tw-mb-0 tw-mt-3.5 tw-overflow-hidden tw-text-[1.35rem] tw-font-semibold tw-leading-snug tw-tracking-tight tw-text-[#1D2D28] dark:tw-text-[#EBE6D9] tw-transition-colors group-hover:tw-text-primary-700 dark:group-hover:tw-text-primary-300 [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box]`}
              >
                {title}
              </p>
              <p className="tw-mb-0 tw-mt-3 tw-hidden sm:tw-block">
                <span className="tw-overflow-hidden tw-text-[14.5px] tw-leading-relaxed tw-text-[#5F6F69] dark:tw-text-[#93A69E] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box]">
                  {description}
                </span>
              </p>
              <p className="tw-mb-0 tw-mt-5 tw-flex tw-items-center tw-justify-between tw-gap-3">
                <span className="tw-font-mono tw-text-[10.5px] tw-font-medium tw-tracking-[0.16em] tw-text-[#8A958F]">
                  @{author}
                </span>
                <span className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-text-primary-700 dark:tw-text-primary-300 tw-transition-all tw-duration-200 group-hover:tw-border-primary-600 group-hover:tw-bg-primary-600 group-hover:tw-text-white">
                  <ArrowIcon className="tw-h-3.5 tw-w-3.5" />
                </span>
              </p>
            </div>
          </div>
        </div>
      </NextLink>
    </div>
  );
};

export default LinkTool;
